import React, { useState, useEffect } from "react";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Seo, SITE_URL } from "./components/Seo";
import JsonData from "./data/data.json";
import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import "./App.css";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Pandobit",
  url: SITE_URL,
  logo: `${SITE_URL}/img/logo.png`,
  description:
    "Pandobit is a software development company building web & mobile apps, UI/UX design, data processing, cybersecurity and AI automation.",
  email: JsonData.Contact?.email,
  telephone: JsonData.Contact?.phone,
  address: {
    "@type": "PostalAddress",
    streetAddress: JsonData.Contact?.address,
    addressLocality: "Ho Chi Minh City",
    addressCountry: "VN",
  },
  sameAs: [JsonData.Contact?.linkedin].filter(Boolean),
};

const ScrollToSection = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const elementId = hash.substring(1);
      const scrollToElement = () => {
        setTimeout(() => {
          scroller.scrollTo(elementId, {
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart'
          });
        }, 500);
      };

      if (document.readyState === 'complete') {
        scrollToElement();
      } else {
        window.addEventListener('load', scrollToElement);
        return () => window.removeEventListener('load', scrollToElement);
      }
    }
  }, [location]);

  return null;
};

const App = () => {
  const [landingPageData] = useState(JsonData);

  return (
    <div>
      <Seo
        path="/"
        title="Pandobit — Web & Mobile App Development, UI/UX, AI & Cybersecurity"
        description="Pandobit is a software development company in Vietnam delivering web & mobile apps, UI/UX design, data processing, cybersecurity and AI workflow automation."
        type="website"
        jsonLd={organizationSchema}
      />
      <ScrollToSection />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Team data={landingPageData.Team} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <Testimonials data={landingPageData.Testimonials} />
    </div>
  );
};

export default App;
